import { socket } from '../socket';
import colors from '../config/colors.json';
import { findMap } from '../helpers/drafting';
import { useSocketEvent, useSocketState } from '../helpers/useSocket';
import React, { useState, useEffect } from 'react';
import { VizierDisplay } from '../components/VizierDisplay';
import { WaterLevel } from '../components/WaterLevel';
import { GoldenAge } from '../components/GoldenAge';
import { Bar } from '../components/Bar100';
import 'chart.js/auto';
import { MalianCows } from '../components/MalianCows';

const isObjectEmpty = (objectName) => {
    return Object.keys(objectName).length === 0
}

export default function LiveGame() {
    const [match] = useSocketState('Match');
    const [config, setConfig] = useState({});
    const [sheepState, setSheepState] = useState({})
    const [vizierState, setVizierState] = useState({})
    const [cisternState, setCisternState] = useState({})
    const [goldenAgeState, setGoldenAgeState] = useState({})
    const [cowState, setCowState] = useState({})

    useSocketEvent('updateConfig', (newdata) => {
        console.log(`Received updateConfig`, newdata);
        setConfig(newdata)
    })

    useSocketEvent('updateSheep', (newData) => {
        setSheepState(newData)
    })

    useSocketEvent('updateVizier', (newData) => {
        setVizierState(newData)
    })

    useSocketEvent('updateCistern', (newData) => {
        setCisternState(newData)
    })

    useSocketEvent('updateGoldenAge', (newData) => {
        setGoldenAgeState(newData)
    })

    useSocketEvent('updateCow', (newData) => {
        setCowState(newData)
    })

    if (!match)
        return <div/>;

    const flipPlayers = match.flipPlayersIngame;

    const leftPlayer = !flipPlayers ? match.leftPlayer : match.rightPlayer;
    const rightPlayer = flipPlayers ? match.leftPlayer : match.rightPlayer;

    const leftColor = colors[leftPlayer.color];
    const rightColor = colors[rightPlayer.color];
    const leftScore = leftPlayer.score;
    const rightScore = rightPlayer.score;

    document.body.style.overflow = "hidden";

    const mapDetails = findMap(match.games.filter(v => v.state === 'upcoming').reverse()[0]?.map);

    return (
        <div className="livegame" style={{
            "--left-player-color": leftColor?.mainColor,
            "--left-player-color-secondary": leftColor.secondaryColor,
            "--right-player-color": rightColor?.mainColor,
            "--right-player-color-secondary": rightColor?.secondaryColor
        }}>
            <link rel="stylesheet" type="text/css" href={`/themes/${config.cssTheme}`} />

            <div className='ingameScoreWrapper'>
                <div className='scoreContainer score-leftScore'>
                    <h1>{leftScore}</h1>
                </div>
                <div className='scoreContainer score-rightScore'>
                    <h1>{rightScore}</h1>
                </div>
            </div>

            <div className='ingameScoreColor'>
				
                <div className={`scoreBannerWrapper-left`}>
					<div className="scoreBanner-img scoreBanner-left"> </div>
					<div className={`scoreBannerColorOverlay scoreBannerColorOverlay-${leftPlayer.color}-left`}></div>
				</div>
                <div className={`scoreBannerWrapper-right`}>
					<div className="scoreBanner-img scoreBanner-right"> </div>
					<div className={`scoreBannerColorOverlay scoreBannerColorOverlay-${rightPlayer.color}-right `}></div>
				</div>
                
            </div>

            <div className='minimapWrapper'>
                <div className='minimapMatchType'>{match.matchType.replace(' - ABBA', "")}</div>
                {
					mapDetails &&
					<div className='minimapMapName'>
                            {mapDetails.label}
                        </div>
                }
				<div className='minimapRoundInfo hidden'>{match.roundInfo}</div>

            </div>

            <div className={`waterLevelWrapper w-[70px] h-[70px] ${cisternState?.leftSide ? 'waterLeft' : 'waterRight'} ${cisternState.showCisternLevel ? 'showCisternLevel' : 'hideCisternLevel'}`} style={{ color: "#F7D79E", backgroundImage: 'url("/sheepCounter/background.png")' }} >
                <WaterLevel waterLevel={cisternState?.waterLevel} widthHeight="w-[62px] h-[62px]" textClass="text-2xl w-[62px] h-[62px] flex text-center justify-center align-center items-center" />
            </div>

            <div className={`goldenAgeWrapper w-[70px] h-[70px] ${goldenAgeState?.leftSide ? 'goldenAgeLeft' : 'goldenAgeRight'} ${goldenAgeState.showGoldenAgeLevel ? 'showGoldenAgeLevel' : 'hideGoldenAgeLevel'}`} style={{ color: "#F7D79E", backgroundImage: 'url("/sheepCounter/background.png")' }} >
                <GoldenAge goldenAgeLevel={goldenAgeState?.goldenAgeLevel} widthHeight="w-[62px] h-[62px]" textClass="text-2xl w-[62px] h-[62px] flex text-center justify-center align-center items-center" />
            </div>

            <div className={`sheepWrapper w-[286px]`}>
                <div className={`sheepCounter top-64 w-[286px] wipe ${sheepState.showSheepPopup ? 'wipe2' : ''}`}>
                  <div className='flex flex-col absolute justify-between w-full h-full p-3'>
                    <div className='h-[20px] relative flex flex-col'>
                      <img className='self-center -mt-5 w-[58px]' src='/sheepCounter/sheepIcon.png' />
                    </div>
                    <div className="grid grid-cols-3 text-2xl braked mx-2">
                        <h1 className="text-white">{parseInt(sheepState.leftCount)}</h1>
                        <h1 className="text-white text-center">{sheepState.neutralCount !== 0 && parseInt(sheepState.neutralCount)}</h1>
                        <h1 className="text-white text-right">{parseInt(sheepState.rightCount)}</h1>
                    </div>
                    <Bar thickness="20px" values={[sheepState.leftCount, sheepState.neutralCount, sheepState.rightCount]} colors={[leftColor?.mainColor, "rgb(255, 255, 255)", rightColor?.mainColor]} />
                  </div>
                  <img className='sheepCounterBackground' src='/sheepCounter/background.png' />
                </div>
            </div>

            <div className={'vizierWrapper'}>
                <div className={`vizierPoints flex flex-row justify-evenly absolute h-[70px] ${vizierState?.leftSide ? 'vizierLeft' : 'vizierRight'}  ${!vizierState?.hasLandmark ? 'min-w-[280px]' : 'min-w-[420px]'}  ${vizierState?.showVizierPopup ? 'showVizierPopup' : 'hideVizierPopup'} `}
                    style={{ backgroundImage: 'url("/vizier/background5.png")' }}>
                    {!isObjectEmpty(vizierState) ? <>
                        <VizierDisplay key={0} pointID={vizierState.points[0]} />
                        <img className='h-2 -mx-3 my-auto' src='/vizier/arrow.png' />
                        <VizierDisplay key={1} pointID={vizierState.points[1]} />
                        <img className='h-2 -mx-3 my-auto' src='/vizier/arrow.png' />
                        <VizierDisplay key={2} pointID={vizierState.points[2]} />
                        <img className='h-2 -mx-3 my-auto' src='/vizier/arrow.png' />
                        <VizierDisplay key={3} pointID={vizierState.points[3]} />
                        <img className='h-2 -mx-3 my-auto' src='/vizier/arrow.png' />
                        <VizierDisplay key={4} pointID={vizierState.points[4]} />
                        {vizierState.hasLandmark ? <>
                            <img className='h-2 -mx-3 my-auto' src='/vizier/arrow.png' />
                            <VizierDisplay key={5} pointID={vizierState.points[5]} />
                            <img className='h-2 -mx-3 my-auto' src='/vizier/arrow.png' />
                            <VizierDisplay key={6} pointID={vizierState.points[6]} />
                            <img className='h-2 -mx-3 my-auto' src='/vizier/arrow.png' />
                            <VizierDisplay key={7} pointID={vizierState.points[7]} />
                        </> : <></>}
                    </> : <></>
                    }
                </div>
            </div>
            <div className={`cowWrapper ${cowState.leftSide ? 'cowCounterLeft' : 'cowCounterRight'} ${cowState.showCowCounter ? 'showCowCounter' : 'hideCowCounter'}`}>
                <MalianCows cowCount={cowState.cowCount} />
            </div>
        </div>
    )
}
